import React from "react";
import EditorialStandards from "src/components/OldBlogPage/components/EditorialStandards/EditorialStandards";
import BlockOfArticles from "src/components/common/BlockOfArticles/BlockOfArticles";
import { createUrl } from "src/utils/helpers/url/createUrl";
import paths from "src/router/paths";
import Typography from "@mui/material/Typography";
import { colors } from "src/config/colors";
import Container from "src/components/common/Layout/Container";
import { SpecialArticleItemSchema } from "src/models/articles/getSpecialArticle";
import { LastArticlesSchema } from "src/models/articles/getLastArticles";
import LinkWithArrow from "src/components/common/Buttons/LinkWithArrow";
import BigArticle from "src/components/BlogPage/components/BigArticle";

interface BlogPageProps {
  pageTitle?: string;
  commonArticlesData: SpecialArticleItemSchema[];
  lastArticlesData: LastArticlesSchema;
}

const BlogPage: React.FC<BlogPageProps> = ({
  pageTitle,
  commonArticlesData,
  lastArticlesData,
}) => {
  return (
    <>
      <Container>
        <Typography
          paddingY="20px"
          fontSize="30px"
          fontWeight={550}
          color={colors.darkBlue}
          component="h1"
          marginBottom={4}
        >
          {pageTitle}
        </Typography>
      </Container>
      {commonArticlesData && (
        <BigArticle
          title={commonArticlesData[0].name}
          date={commonArticlesData[0].date}
          img={commonArticlesData[0].image}
          slug={commonArticlesData[0].slug}
        />
      )}
      <EditorialStandards />
      <BlockOfArticles
        title="Последние статьи"
        footerAction={
          <LinkWithArrow
            href={createUrl([paths.BLOG, paths.ARTICLES])}
            title="Последние статьи"
          />
        }
        gridLg={3}
        lastArticlesData={lastArticlesData.articles}
      />
    </>
  );
};

export default BlogPage;
